<div class="container py-3">
    <!-- <p>Welcome, {{user.firstName}}!</p> -->
    <!-- <p>You're logged in with Angular 10!!</p>
    <p><a routerLink="/admin/users" routerLinkActive="active">Manage Users</a></p>
    <p><a routerLink="/user/edit" routerLinkActive="active">Edit Profile</a></p> -->
    <!-- <app-calendar></app-calendar> -->
</div>
